import { render, staticRenderFns } from "./StageSlide.vue?vue&type=template&id=4a8c911e&functional=true&"
import script from "./StageSlide.vue?vue&type=script&lang=ts&"
export * from "./StageSlide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports